import { useContext, useState } from 'react';
import { OrderContext } from 'app/javascript/ui/run/RunShow/OrderStore/index';
import { BrokerageConfig } from './type';
import { InstrumentType } from 'v3/common/types/type';
import { RenderBrokerage } from './RenderBrokerage';
import { BrokerageModal } from './BrokerageModal';

type OrderContextType = {
  shouldShowBrokerage: boolean;
  setState: React.Dispatch<React.SetStateAction<{ shouldShowBrokerage: boolean }>>;
  brokerageConfig: BrokerageConfig;
  availableBrokerageSegments: InstrumentType[];
};

const Brokerage = () => {
  const context = useContext(OrderContext) as OrderContextType | null;

  const [isModalVisible, setIsModalVisible] = useState(false);
  if (!context) return null;

  const { shouldShowBrokerage, setState, brokerageConfig, availableBrokerageSegments } = context;
  if (!brokerageConfig) return null;

  const toggleBrokerage = () =>
    setState((prev: { shouldShowBrokerage: boolean }) => ({
      ...prev,
      shouldShowBrokerage: !prev.shouldShowBrokerage,
    }));

  const toggleModal = () => setIsModalVisible((prev) => !prev);
  const closeModal = () => setIsModalVisible(false);
  const disbledShouldShow = availableBrokerageSegments.length === 0;
  return (
    <div className="brokerage-container">
      <div className="card">
        <div className="card-body d-flex align-items-center justify-content-center p-2 gap-5">
          <input
            id="brokerage-checkbox"
            type="checkbox"
            className="brokerage-checkbox"
            checked={shouldShowBrokerage}
            onChange={toggleBrokerage}
          />
          <label htmlFor="brokerage-checkbox" className="tx-12 mb-0">
            Brokerage Charges
          </label>

          {shouldShowBrokerage && (
            <button
              disabled={disbledShouldShow}
              onClick={toggleModal}
              className={`btn-sm btn-outline-primary brokerage-show-btn ${disbledShouldShow ? 'disabled' : ''}`}
            >
              Show
            </button>
          )}
        </div>
      </div>

      <BrokerageModal
        onClose={closeModal}
        show={isModalVisible}
        title="Brokerage Charges"
        titleCls="brokerage-modal-header"
      >
        <RenderBrokerage
          brokerageConfig={brokerageConfig}
          availableBrokerageSegments={availableBrokerageSegments}
        />
      </BrokerageModal>
    </div>
  );
};

export default Brokerage;
